import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import React from 'react'
import iconError from '../../assets/imagens/icon-error.svg'
import { bool, func, string } from 'prop-types'
import styled from 'styled-components'

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  .button-bottom-modal {
    margin-top: 20px;
    button {
      width: 100%;
    }
  }
`

const Icon = styled.span`
  background-image: url( ${iconError} );
  background-position: center;
  background-size: cover;
  display: block;
  margin: 0 auto;
  min-height: 40px;
  width: 40px;
`

const Titulo = styled.h3`
  ${StyleGuide.tipografia.titulo3};
  color: ${StyleGuide.cores.vermelhoErro};
  ${StyleGuide.boldFonte};
  margin: 12px 0;
`

const Descricao = styled.p`
  color: ${StyleGuide.cores.cinza500};
  ${StyleGuide.tipografia.textoPequeno};

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin-bottom: 20px;
  }
`

const ModalErro = ( { acaoTitulo, descricao, showModal, titulo, toggleModal, bottomMessage } ) => {
  return (
    <Modal
      altura="auto"
      largura="350px"
      onShowModal={ toggleModal }
      show={ showModal }
    >
      <ModalWrapper>
        <Icon />

        <Titulo>{titulo}</Titulo>

        <Descricao>{descricao}</Descricao>

        {bottomMessage}

        <div className="button-bottom-modal">
          <Button
            invertido
            onClick={ toggleModal }
            tema={ Button.BOTAO_PRETO }
          >
            {acaoTitulo}
          </Button>
        </div>
      </ModalWrapper>
    </Modal>
  )
}

ModalErro.propTypes = {
  'acaoTitulo': string,
  'descricao': string.isRequired,
  'showModal': bool,
  'titulo': string.isRequired,
  'toggleModal': func.isRequired,
  'bottomMessage': string.isRequired,
}

ModalErro.defaultProps = {
  'acaoTitulo': 'OK, entendi',
  'showModal': false
}

export default ModalErro
